// src/components/modals/CreateFolderModal.jsx

import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import "./ObjectExplorerModals.css";

const CreateFolderModal = ({
  show,
  onHide,
  bucketName,
  currentPath = "",
  refreshObjects
}) => {
  const [folderName, setFolderName] = useState("");
  const [creating, setCreating] = useState(false);

  const handleCreateFolder = async () => {
    if (!folderName.trim()) {
      alert("Informe o nome da pasta");
      return;
    }

    setCreating(true);
    try {
      const token = localStorage.getItem("token");

      // envia exatamente o que o backend espera
      await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/api/buckets/${bucketName}/folder`,
        {
          folderName: folderName.trim(),
          parent: currentPath  // <-- era parentPath, agora é parent
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log("✅ Pasta criada com sucesso");
      setFolderName("");
      onHide();
      refreshObjects();
    } catch (error) {
      console.error("❌ Erro ao criar pasta:", error.response?.data || error);
      alert("Erro ao criar pasta");
    } finally {
      setCreating(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="object-modal">
      <Modal.Header closeButton>
        <Modal.Title>Criar Pasta</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="object-modal-callout mb-3">
          Crie uma nova pasta dentro de <strong>{currentPath || `${bucketName}/`}</strong>.
        </div>
        <Form.Group controlId="formFolderName">
          <Form.Label>Nome da Pasta</Form.Label>
          <Form.Control
            type="text"
            placeholder="Digite o nome da nova pasta"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            disabled={creating}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={creating}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleCreateFolder}
          disabled={creating}
        >
          {creating ? "Criando..." : "Criar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateFolderModal;
